const state = {
    all: [],
    active: {}
}

const getters = {
    allScenes: (state) => state.all,
    activeScene: (state) => state.active,
}

const actions = {
    async loadScenes({
        commit
    }, file = 'data/content.json') {
        fetch(file)
            .then(response => {
                return response.json();
            })
            .then(c => {
                commit('setScenes', c.scenes);
            })
    },
    activateScene({
        commit
    }, scene) {
        commit('setActive', scene)
    },
    activateSceneName({
        commit,
        state
    }, scenename) {
        var scene = state.all[scenename];
        if (scene) {
            commit('setActive', scene);
        }
    },
    clearActivateScene({
        commit
    }) {
        commit('setActive', {})
    }
}

const mutations = {
    setScenes: (state, scenes) => (state.all = scenes),
    setActive: (state, scene) => (state.active = scene),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}